export default class SocketService {

      static async connect(socket) {
            await socket.connect();
      }

      static async disconnect(socket) {
            await socket.disconnect();
      }

}
